"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let UpdateModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.version = new VersionModel();
  }
};
UpdateModel.model = "client.update";
UpdateModel = __decorateClass([
  Annotation.ModelMeta
], UpdateModel);
export let VersionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.force = false;
    this.last = "";
    this.package = "";
  }
};
VersionModel.model = "version";
VersionModel = __decorateClass([
  Annotation.ModelMeta
], VersionModel);
